var _g, _path, _path2, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 1221,
    viewBox: "0 0 1400 1221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_612_5737)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 481,
    r: 279,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M893.465 614.978C812.373 755.433 632.773 803.557 492.317 722.465C351.862 641.373 303.738 461.773 384.83 321.317C465.922 180.862 645.522 132.738 785.978 213.83C926.433 294.922 974.557 474.522 893.465 614.978ZM434.396 349.934C369.108 463.015 407.853 607.612 520.934 672.899C634.015 738.187 778.612 699.442 843.899 586.361C909.187 473.28 870.442 328.683 757.361 263.396C644.28 198.108 499.683 236.853 434.396 349.934Z",
    fill: "#264187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M816.046 570.226C759.779 667.684 635.159 701.076 537.701 644.809C440.243 588.541 406.851 463.922 463.119 366.464C519.386 269.005 644.006 235.614 741.464 291.881C838.922 348.149 872.314 472.768 816.046 570.226ZM497.511 386.32C452.21 464.784 479.094 565.115 557.558 610.416C636.021 655.718 736.353 628.834 781.654 550.37C826.955 471.906 800.071 371.575 721.608 326.273C643.144 280.972 542.812 307.856 497.511 386.32Z",
    fill: "#1B47B8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_612_5737",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M758.27 536.856C720.555 602.179 637.026 624.561 571.702 586.846C506.379 549.132 483.997 465.603 521.712 400.279C559.426 334.955 642.956 312.574 708.279 350.288C773.603 388.003 795.984 471.532 758.27 536.856ZM544.764 413.588C514.4 466.18 532.419 533.43 585.012 563.794C637.604 594.158 704.853 576.139 735.218 523.547C765.582 470.954 747.562 403.705 694.97 373.341C642.378 342.976 575.128 360.996 544.764 413.588Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.27 536.856C720.555 602.179 637.026 624.561 571.702 586.846C506.379 549.132 483.997 465.603 521.712 400.279C559.426 334.955 642.956 312.574 708.279 350.288C773.603 388.003 795.984 471.532 758.27 536.856ZM544.764 413.588C514.4 466.18 532.419 533.43 585.012 563.794C637.604 594.158 704.853 576.139 735.218 523.547C765.582 470.954 747.562 403.705 694.97 373.341C642.378 342.976 575.128 360.996 544.764 413.588Z",
    fill: "#1B47B8",
    stroke: "#FFCC00",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    mask: "url(#path-4-inside-1_612_5737)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_612_5737",
    x: -79.9998,
    y: -259,
    width: 1480,
    height: 1480,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 230.5,
    result: "effect1_foregroundBlur_612_5737"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.20f9c3d5d153eb918895818a7c9fe20d.svg";
export { ForwardRef as ReactComponent };